<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "host-product",
  data() {
    return {
    }
  },
}
</script>

<style lang="scss" scoped>
</style>